// URL ↔ internal category slug mapping.
//
// Internal slugs (`transfers`, `beaches`) are kept for backward compatibility
// with seeded experience records, the `category_images` collection, the
// translation keys (`cat_transfers`, `cat_beaches`) and the FilterBar config.
// Public-facing URLs use friendly aliases that match the visible labels:
//   `transfers` → `travel-essentials`
//   `beaches`   → `hotels`
//
// Both directions accept the old internal slug too so any external links
// still pointing at `?category=transfers` or `?category=beaches` keep
// resolving to the same filtered view.

const INTERNAL_TO_URL = {
  transfers: 'travel-essentials',
  beaches: 'hotels',
};

const URL_TO_INTERNAL = {
  'travel-essentials': 'transfers',
  hotels: 'beaches',
};

export function toUrlCategorySlug(internalSlug) {
  if (!internalSlug) return internalSlug;
  return INTERNAL_TO_URL[internalSlug] || internalSlug;
}

export function fromUrlCategorySlug(urlSlug) {
  if (!urlSlug) return urlSlug;
  return URL_TO_INTERNAL[urlSlug] || urlSlug;
}
